import React, { useState, useEffect } from "react";
import { If } from "react-condition";
import RSelect from "react-select";
import SelectChild from "../SelectChild";
import TextField from "../ApplicationView/TextField";
import Checkbox from "../ApplicationView/Checkbox";
import Radio from "../ApplicationView/Radio";
import TextArea from "../ApplicationView/TextArea";
import EmailField from "../ApplicationView/EmailField";
import PasswordField from "../ApplicationView/PasswordField";
import NumberField from "../ApplicationView/NumberField";
import DateField from "../ApplicationView/DateField";
import Paragraph from "../ApplicationView/Paragraph";
import MultiSelect from "./MultiSelect";
import FileInput from "./FileInput";
import ProfessionalExperience from "./ProfessionalExperience";
import { useLocation } from "react-router-dom/cjs/react-router-dom.min";
import DateTime from "./DateTime";

function Select({
  onBlurHandler,
  isInputFieldTouched,
  data,
  defaultValue,
  isPreview,
  approve,
  isChild,
  ocrDisabled,
  errorInputs,
  tokenType,
}) {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const refcode = searchParams.get("refcode" || "");
  const source = searchParams.get("source" || "");
  const client = searchParams.get("client", "");
  const consultant = searchParams.get("consultant_name", "");

  //Select child -Lovejot(12-DEC-2022)

  const [element, setElement] = useState({
    type: "select",
    properties: {
      label: "Select question field.",
      options: [],
    },
    multiple: false,
    required: false,
  });

  // useEffect(() => {
  //   setElement(data)
  //   setValue(data.properties.value)
  // }, [data.properties.value])

  const [value, setValue] = useState("");

  const [readOnly, setReadOnly] = useState(false);
  const [hasChiledReadOnly, setHasChildReadOnly] = useState(false);

  async function showData() {
    if (data.properties.label === "How did you come to know about us") {
      if (!data?.properties?.value) {
        setReadOnly(false);
      } else {
        setReadOnly(true);
      }
      setHasChildReadOnly(true);
    } else {
      setReadOnly(false);
      setHasChildReadOnly(false);
    }
    // if (
    //   data.properties.label === "How did you come to know about us" ||
    //   data.properties.label === "Select Consultancy Name"
    // ) {

    //   if (data.properties.label === "How did you come to know about us") {
    //     if (
    //       !data?.properties?.value ||
    //       localStorage.getItem("user.email") === "ankit.patel@maxicus.com"
    //     ) {
    //       setReadOnly(false);
    //     } else {
    //       if (source === "Employee reference" && !refcode && !client) {
    //         setValue("");
    //       } else {
    //         setValue(data.properties.value);
    //         setReadOnly(true);
    //       }
    //     }
    //   }
    // }
  }

  useEffect(() => {
    setValue(data.properties.value ? data.properties.value : "");
  },[data.properties.value])

  useEffect(() => {
    let obj = { ...data };
    // if (isChild) {
    //   obj.properties.required = true;
    // }
    setElement((prev) => ({ ...prev, ...obj }));
  }, [isChild, data]);

  //check prefilled field -Lovejot(07-DEC-2022)
  useEffect(() => {
    showData();
    if (!isPreview) {
      if (data.properties.label === "How did you come to know about us") {
        // if (refcode) {
        //   //  data.properties.value = "Employee reference" ? "Employee reference" : "";
        //   setReadOnly(true);
        // }else
        if (client && refcode && !source) {
          const removeRef = data?.properties?.options?.filter((ele) => {
            return ele !== "Employee reference";
          });
          data.properties.options = removeRef;
        } else {
          const removeRef = data?.properties?.options?.filter((ele) => {
            return ele !== "Employee reference";
          });
          data.properties.options = removeRef;
        }

        if (consultant && source) {
          const removeRef = data?.properties?.options?.filter((ele) => {
            return ele !== "Consultant";
          });
          data.properties.options = removeRef;
        } else {
          const removeRef = data?.properties?.options?.filter((ele) => {
            return ele !== "Consultant";
          });
          data.properties.options = removeRef;
        }
      }
    }
    // if (
    //   data?.disableField === true &&
    //   data?.properties?.value &&
    //   data?.properties?.value?.length !== 0 &&
    //   localStorage.getItem("user.role") !== "admin"
    // ) {
    //   setReadOnly(true);
    // } else {
    //   setReadOnly(false);
    // }
  }, [data]);

  useEffect(() => {
    const labelsToCheck = [
      "Bank Name",
      "Highest qualification",
      "Select caste category.",
      "Blood Group",
    ];
    const currentLabel = data?.properties?.label;

    if (labelsToCheck.includes(currentLabel)) {
      const currentValue = data?.properties?.value?.trim()?.toLowerCase() || "";
      const comparisonValue = data?.comparison || "";
      if (comparisonValue !== currentValue) {
        setElement((prev) => ({ ...prev, isEdited: true }));
      }else{
        setElement((prev) => ({ ...prev, isEdited: false }));
      }
    }
  }, [data?.properties?.value]);

  const handleChange = (val) => {
    const editableLabels = [
      "Bank Name",
      "Highest qualification",
      "Select caste category.",
      "Blood Group",
    ];

    const currentLabel = element?.properties?.label;

    if (editableLabels.includes(currentLabel)) {
      const inputValue = val?.trim()?.toLowerCase() || "";
      const comparisonValue = element?.comparison || "";
      console.log({comparisonValue,inputValue})

      setElement((prev) => ({
        ...prev,
        isEdited: comparisonValue !== inputValue,
      }));
    }
  };

  const foundError = errorInputs?.find(
    (ele) => ele?.label === element?.properties?.label
  );

  return (
    <div className="form-group mb-3 col-md-12 form-builder-element">
      <label htmlFor="">
        {element?.properties?.label}
        <If test={element?.properties?.required === true}>
          <span style={{ color: "red" }}>*</span>
        </If>
      </label>

      <div
        className="form-view"
        label={element?.properties?.label}
        data={JSON.stringify(element)}
        value={value}
      >
        <RSelect
          onBlur={onBlurHandler}
          value={{
            //label: value,
            label: value === null ? setValue(element.properties.value) : value,
            value: value,
          }}
          options={[
            { label: "Select...", value: "" },
            ...element.properties.options.map((option) => ({
              label: option,
              value: option.trim(),
            })),
          ]}
          className={`${foundError ? "border border-danger" : ""}`}
          onChange={(e) => {
            setValue(e.value);
            handleChange(e.value);
            if (isInputFieldTouched) {
              isInputFieldTouched();
            }
          }}
          isDisabled={readOnly || approve || !element.editable || ocrDisabled}
        ></RSelect>
        {foundError && <p className="text-danger">{foundError?.value}</p>}
      </div>

      {data?.parent &&
        data?.parent.map((ele) => {
          ele.child.editable = true;
          if (ele?.pValue === value) {
            switch (ele?.child?.type) {
              case "select":
                return (
                  <SelectChild
                    defaultValue={defaultValue}
                    isChild={true}
                    key={ele.child.id}
                    data={ele.child}
                    errorInputs={errorInputs}
                    editable={!element.editable}
                    approve={approve}
                    hasChiledReadOnly={hasChiledReadOnly}
                    tokenType={tokenType}
                  />
                );
              case "text":
                return (
                  <TextField
                    defaultValue={defaultValue}
                    isChild={true}
                    key={ele.child.id}
                    data={ele.child}
                    errorInputs={errorInputs}
                    approve={approve}
                    hasChiledReadOnly={hasChiledReadOnly}
                  />
                );
              case "email":
                return (
                  <EmailField
                    defaultValue={defaultValue}
                    isChild={true}
                    key={ele.child.id}
                    data={ele.child}
                    errorInputs={errorInputs}
                    approve={approve}
                    hasChiledReadOnly={hasChiledReadOnly}
                  />
                );
              case "radio":
                return (
                  <Radio
                    defaultValue={defaultValue}
                    isChild={true}
                    key={ele.child.id}
                    data={ele.child}
                    errorInputs={errorInputs}
                    approve={approve}
                    hasChiledReadOnly={hasChiledReadOnly}
                  />
                );
              case "checkbox":
                return (
                  <Checkbox
                    defaultValue={defaultValue}
                    isChild={true}
                    key={ele.child.id}
                    data={ele.child}
                    errorInputs={errorInputs}
                    approve={approve}
                    hasChiledReadOnly={hasChiledReadOnly}
                  />
                );
              case "number":
                return (
                  <NumberField
                    defaultValue={defaultValue}
                    isChild={true}
                    key={ele.child.id}
                    data={ele.child}
                    errorInputs={errorInputs}
                    approve={approve}
                    hasChiledReadOnly={hasChiledReadOnly}
                  />
                );
              case "textarea":
                return (
                  <TextArea
                    defaultValue={defaultValue}
                    isChild={true}
                    key={ele.child.id}
                    data={ele.child}
                    errorInputs={errorInputs}
                    approve={approve}
                    hasChiledReadOnly={hasChiledReadOnly}
                  />
                );
              case "date":
                return (
                  <DateField
                    defaultValue={defaultValue}
                    isChild={true}
                    key={ele.child.id}
                    data={ele.child}
                    errorInputs={errorInputs}
                    approve={approve}
                    hasChiledReadOnly={hasChiledReadOnly}
                  />
                );
              case "password":
                return (
                  <PasswordField
                    defaultValue={defaultValue}
                    isChild={true}
                    key={ele.child.id}
                    data={ele.child}
                    errorInputs={errorInputs}
                    approve={approve}
                    hasChiledReadOnly={hasChiledReadOnly}
                  />
                );
              case "paragraph":
                return (
                  <Paragraph
                    defaultValue={defaultValue}
                    isChild={true}
                    key={ele.child.id}
                    data={ele.child}
                    approve={approve}
                    hasChiledReadOnly={hasChiledReadOnly}
                  />
                );
              case "multiSelect":
                return (
                  <MultiSelect
                    defaultValue={defaultValue}
                    isChild={true}
                    key={ele.child.id}
                    data={ele.child}
                    errorInputs={errorInputs}
                    approve={approve}
                    hasChiledReadOnly={hasChiledReadOnly}
                  />
                );
              case "datetime":
                return (
                  <DateTime
                    defaultValue={defaultValue}
                    isChild={true}
                    key={ele.child.id}
                    data={ele.child}
                    errorInputs={errorInputs}
                    approve={approve}
                    hasChiledReadOnly={hasChiledReadOnly}
                  />
                );
              case "file":
                return (
                  <FileInput
                    defaultValue={defaultValue}
                    isChild={true}
                    key={ele.child.id}
                    errorInputs={errorInputs}
                    data={ele.child}
                    approve={approve}
                    hasChiledReadOnly={hasChiledReadOnly}
                  />
                );
              case "professionalexperience":
                return (
                  <ProfessionalExperience
                    defaultValue={defaultValue}
                    isChild={true}
                    key={ele.child.id}
                    data={ele.child}
                    approve={approve}
                    errorInputs={errorInputs}
                    hasChiledReadOnly={hasChiledReadOnly}
                  />
                );
              default:
                return null;
            }
          }
          return null;
        })}
    </div>
  );
}

export default Select;
